import { useEffect, useState, useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
// import { Select, Option } from "src/components/select";
import Table from 'src/components/table/table'
// import { SubjectSelect, GradeSelect } from "src/components/common";
import { getStudentLessonsRequest } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import PracticeRow from './components/practice-row'

export const StudentLessons = () => {
  const history = useHistory()
  const { showNotificationHelper } = useNotification()

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0)
  const [perPage, setPerPage] = useState(5)
  const [pageCount, setPageCount] = useState(0)
  const [filter, setFilter] = useState({
    period: 'month',
    // subject_id: null,
    // grade_id: null,
    // status: null,
  })

  useEffect(() => {}, [])

  const fetchData = useCallback(async ({ pageSize, pageIndex, filterData }) => {
    try {
      setLoading(true)
      const response = await getStudentLessonsRequest({
        ...filterData,
        page: pageIndex + 1,
        perPage: pageSize,
      })
      setPage(pageIndex)
      setItems(response.data.items.filter((x) => x.task))
      setCount(response.data.total)
      setPageCount(Math.ceil(response.data.total / pageSize))
    } catch (error) {
      showNotificationHelper({
        type: 'fail',
        title: 'Error!',
        body: error.message,
      })
    }
    setLoading(false)
  }, [])

  const handleRowClick = (id) => () => {
    history.push(routes.lessons.queue(id))
  }

  return (
    <>
      <div className="sectionHb-top">
        <h2 className="sectionHb-title">Assignments</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <Table
            curPage={page}
            perPage={perPage}
            data={items}
            fetchData={fetchData}
            pageCount={pageCount}
            filter={filter}
            loading={loading}
            rowComponent={(item) => (
              <PracticeRow
                key={item?.task_id}
                item={item.task}
                onClick={handleRowClick(item?.task_id)}
                active={item.active}
                // actions={
                //   {
                //     onEdit,
                //     onDelete,
                //     onAssignStudents,
                //     onAssignClassrooms,
                //     onSendToMark,
                //   }
                // }
              />
            )}
          />
        </div>
      </div>
    </>
  )
}
